import { Theme } from '@mui/material/styles';

// =============================================================================
// TABLE STYLING UTILITIES
// =============================================================================

/**
 * Standard table row styling for clickable rows with hover effects
 */
export const getClickableRowStyles = (theme: Theme) => ({
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.palette.action.hover
    }
});

/**
 * Standard table cell styling for consistent appearance
 */
export const getTableCellStyles = (isMobile: boolean) => ({
    minWidth: isMobile ? 120 : 'auto',
    maxWidth: isMobile ? 200 : 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const
});

/**
 * Standard table header cell styling
 */
export const getTableHeaderCellStyles = (isMobile: boolean) => ({
    minWidth: isMobile ? 120 : 'auto',
    whiteSpace: 'nowrap' as const
}); 